import { useRepositoryMutation } from '@mews-commander/data-access';
import { MewsTeam } from '@mews/enums';

export const useUpdateRoutingRulesMutation = ({
    onSuccess,
}: {
    onSuccess: (ruleId?: string) => void;
    routingRuleId?: string;
}) =>
    useRepositoryMutation('routingRules', 'newUpdate', {
        invalidateQueries: {
            routingRules: ['newGetAll'],
        },
        onSuccess: (data) => {
            const ruleId = data?.routingRules?.[0]?.id;
            onSuccess(ruleId);
        },
        meta: {
            logError: {
                team: MewsTeam.Spacetime,
            },
        },
    });
